import styled from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const AppNavMobile = styled.div `
  display: flex;
  align-items: center;
  margin: ${units(0.5)} ${units(4)} ${units(0.5)} 0;

  button > * {
    display: flex;
  }
`;
export const AppNavMobileSelectedText = styled.span `
  display: flex;
  ${typeStyle("labelL")};
  line-height: 1;
  color: ${color("contrast")};
  margin-left: ${units(1.5)};
`;
